const Controller = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      x='0px'
      y='0px'
      width='85'
      height='85'
      viewBox='0 0 172 172'
    >
      <g
        fill='none'
        fill-rule='nonzero'
        stroke='none'
        stroke-width='1'
        stroke-linecap='butt'
        stroke-linejoin='miter'
        stroke-miterlimit='10'
        stroke-dasharray=''
        stroke-dashoffset='0'
        font-family='none'
        font-weight='none'
        font-size='none'
        text-anchor='none'
      >
        <path d='M0,172v-172h172v172z' fill='none'></path>
        <path
          d='M43,172c-23.74824,0 -43,-19.25176 -43,-43v-86c0,-23.74824 19.25176,-43 43,-43h86c23.74824,0 43,19.25176 43,43v86c0,23.74824 -19.25176,43 -43,43z'
          fill='var(--backgroundGreenDark)'
        ></path>
        <g fill='var(--primaryGreen)'>
          <path d='M47.19035,33.69693c-0.09756,0.01774 -0.19511,0.04434 -0.2838,0.07095c-1.05538,0.23946 -1.80036,1.18841 -1.77375,2.2704v15.8928h-4.5408c-3.85791,0 -6.8112,2.95329 -6.8112,6.8112v4.5408c0,3.85791 2.95329,6.8112 6.8112,6.8112h13.6224c3.85791,0 6.8112,-2.95329 6.8112,-6.8112v-4.5408c0,-3.85791 -2.95329,-6.8112 -6.8112,-6.8112h-4.5408v-15.8928c0.02661,-0.65629 -0.23946,-1.28597 -0.7095,-1.72941c-0.47891,-0.4523 -1.12633,-0.67402 -1.77375,-0.61194zM85.78715,33.69693c-0.09756,0.01774 -0.19511,0.04434 -0.2838,0.07095c-1.05538,0.23946 -1.80036,1.18841 -1.77375,2.2704v63.5712h-4.5408c-3.85791,0 -6.8112,2.95329 -6.8112,6.8112v4.5408c0,3.85791 2.95329,6.8112 6.8112,6.8112h13.6224c3.85791,0 6.8112,-2.95329 6.8112,-6.8112v-4.5408c0,-3.85791 -2.95329,-6.8112 -6.8112,-6.8112h-4.5408v-63.5712c0.02661,-0.65629 -0.23946,-1.28597 -0.7095,-1.72941c-0.47891,-0.4523 -1.12633,-0.67402 -1.77375,-0.61194zM124.38395,33.69693c-0.09756,0.01774 -0.19511,0.04434 -0.2838,0.07095c-1.05538,0.23946 -1.80036,1.18841 -1.77375,2.2704v22.704h-4.5408c-3.85791,0 -6.8112,2.95329 -6.8112,6.8112v4.5408c0,3.85791 2.95329,6.8112 6.8112,6.8112h13.6224c3.85791,0 6.8112,-2.95329 6.8112,-6.8112v-4.5408c0,-3.85791 -2.95329,-6.8112 -6.8112,-6.8112h-4.5408v-22.704c0.02661,-0.65629 -0.23946,-1.28597 -0.7095,-1.72941c-0.47891,-0.4523 -1.12633,-0.67402 -1.77375,-0.61194zM45.1328,72.36468v15.4671c-0.01774,0.1419 -0.01774,0.2838 0,0.4257v47.6784c-0.00887,0.81592 0.41683,1.57864 1.12633,1.99547c0.7095,0.40796 1.57864,0.40796 2.28814,0c0.7095,-0.41683 1.1352,-1.17954 1.12633,-1.99547v-47.6784c0.01774,-0.1419 0.01774,-0.2838 0,-0.4257v-15.4671zM122.3264,79.17588v15.4671c-0.01774,0.1419 -0.01774,0.2838 0,0.4257v40.8672c-0.00887,0.81592 0.41683,1.57864 1.12633,1.99547c0.7095,0.40796 1.57864,0.40796 2.28814,0c0.7095,-0.41683 1.1352,-1.17954 1.12633,-1.99547v-40.8672c0.01774,-0.1419 0.01774,-0.2838 0,-0.4257v-15.4671zM83.7296,120.04308v4.1151c-0.01774,0.1419 -0.01774,0.2838 0,0.4257v11.352c-0.00887,0.81592 0.41683,1.57864 1.12633,1.99547c0.7095,0.40796 1.57864,0.40796 2.28814,0c0.7095,-0.41683 1.1352,-1.17954 1.12633,-1.99547v-11.352c0.01774,-0.1419 0.01774,-0.2838 0,-0.4257v-4.1151z'></path>
        </g>
      </g>
    </svg>
  );
};

export default Controller;
